import { Helmet } from 'react-helmet-async'
import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Footer } from './Footer'
import { ScrollToTop } from '../../lib/ScrollToTop'
import { useSmoothScroll } from '../../lib/useSmoothScroll'
import { organizationJsonLd } from '../../lib/seo'

export function Layout() {
  useSmoothScroll()

  return (
    <div className="flex min-h-screen flex-col">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(organizationJsonLd())}</script>
      </Helmet>
      <ScrollToTop />
      <Header />
      <main className="flex-1 pt-16 lg:pt-20">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
